import { render } from "./ImgVertical.vue?vue&type=template&id=3859b1de&scoped=true"
import script from "./ImgVertical.vue?vue&type=script&lang=js"
export * from "./ImgVertical.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "./ImgVertical.vue?vue&type=style&index=1&id=3859b1de&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3859b1de"]])

export default __exports__